import React, { useState, useEffect } from "react";
import RatingService from "../Rating/RatingService";
import "./RatingUpdate.css";

const RatingUpdate = () => {
  const [rating, setRating] = useState(0);
  const [officeRating, setOfficeRating] = useState(0);
  const [reason, setReason] = useState("");
  const [extraNotes, setExtraNotes] = useState("");
  const [appointmentId, setAppointmentId] = useState(sessionStorage.getItem("appointmentId") || "");
  const [anonymous, setAnonymous] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (appointmentId) {
      RatingService.getRatingByAppointmentId(appointmentId)
        .then(data => {
          if (data) {
            setRating(data.rating || 0);
            setOfficeRating(data.officeRating || 0);
            setReason(data.reason || "");
            setExtraNotes(data.extraNotes || "");
            setAnonymous(data.anoymonous || false);
          }
        })
        .catch(console.error);
    }
  }, [appointmentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedData = {
      rating,
      officeRating,
      reason,
      extraNotes,
      appointmentId: anonymous ? 0 : parseInt(appointmentId),
      type: "",
      anoymonous: anonymous
    };

    try {
      const result = await RatingService.updateRatingByAppointmentId(appointmentId, updatedData);
      setMessage("Rating updated successfully!");
    } catch (err) {
      console.error(err);
      setMessage("Failed to update rating.");
    }
  };

  const renderRatingScale = (value, setValue, label) => (
    <div className="rating-section">
      <label>{label}</label>
      <div className="rating-scale">
        {[...Array(10)].map((_, i) => (
          <button
            key={i + 1}
            className={value === i + 1 ? "selected" : ""}
            onClick={() => setValue(i + 1)}
            type="button"
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="rating-form-container">
      <h2>Update Your Rating</h2>
      <form onSubmit={handleSubmit}>
        {renderRatingScale(rating, setRating, "Rate Your Experience (1-10)")}
        {renderRatingScale(officeRating, setOfficeRating, "Rate the Office (1-10)")}

        <label>Reason for Rating</label>
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} />

        <label>Additional Notes</label>
        <textarea value={extraNotes} onChange={(e) => setExtraNotes(e.target.value)} />

        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={anonymous}
            onChange={() => setAnonymous(!anonymous)}
          />
          Submit as Anonymous
        </label>

        <button type="submit" className="submit-btn">Submit Rating</button>
      </form>
      {message && <p className="form-message">{message}</p>}
    </div>
  );
};

export default RatingUpdate;
